import { CourseDto } from "./courseDto";

export class ModuleDto {
  id: number;
  title: string;
  orderOnPath: number;
  moduleDuration: string;
  trainingPathTranslationID: number;
  courseDtoList: CourseDto[];
}
